import Big from "big.js"
import React from "react"

import { Icon } from "../../display/Icon"
import { Row } from "../../layout/FlexBox"
import { MoneyInput } from "../field/MoneyInput"
import { InputRow } from "./InputRow"

type MoneyRangeType = [Big | undefined, Big | undefined]

type MoneyRangeRowProps = {
  value: MoneyRangeType
  onChange: (moneyRange: MoneyRangeType) => void
}

export { MoneyRangeRow, MoneyRangeType }

function MoneyRangeRow(props: MoneyRangeRowProps) {
  return (
    <InputRow icon={{ name: "currency-eur" }}>
      <PriceInput {...props} index={0} />
      <Icon name="arrow-right" />
      <PriceInput {...props} index={1} />
    </InputRow>
  )
}

function PriceInput(props: MoneyRangeRowProps & { index: 0 | 1 }) {
  const onSubmit = (value?: Big) => {
    const range = [...props.value] as MoneyRangeType
    range[props.index] = value
    props.onChange(range)
  }

  return (
    <Row expand>
      <MoneyInput
        mini
        style={{ maxWidth: 90 }}
        value={props.value[props.index]}
        onSubmit={onSubmit}
      />
    </Row>
  )
}
